<template>
  <section class="container-position">
    <button
      @click="Refresh()"
      class="update-info__button"
      :class="{'rotate-button': loading}"
    >
      <CIcon customClasses="update-info__button--icon" name="cil-sync" />
    </button>
  </section>
</template>
<script>
export default {
  name: "ButtonRefresh",
  props: ["dadosFiltradosCompanyPhone", "loading"],
  data() {
    return {
      filtro: this.dadosFiltradosCompanyPhone
    }
  },
  methods: {
    Refresh() {
      setTimeout(() =>{
        this.filtro.telefone = this.dadosFiltradosCompanyPhone.telefone
        this.filtro.contaId = this.dadosFiltradosCompanyPhone.contaId
        this.$emit("filter-button", this.filtro, "FILTER_MESSAGES")
      },300)
    }
  }
}
</script>

<style lang="scss">
.container-position {
  display: flex;
}

@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
  to {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
  to {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

.rotate-button {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}
.update-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: rgb(132, 132, 132);
  margin-bottom: 1rem;

  span {
    margin-right: 0.5rem;
  }

  &__button {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;

    &:focus {
      outline: none;
    }

    &--icon {
      width: 1.1rem;
      height: 1.1rem;
      fill: rgb(255, 255, 255);
    }
  }
}
</style>
